export default __webpack_public_path__ + "static/media/Leaders_BG-01.3bd7e3da.png";